import Request from ".";
import { Routes } from "../constant/api_url";

export const getLeaves = async (data) => {
  const result = await Request.post(Routes.GETLEAVES, data, {
    headers: { Accept: "application/json, */*", "Content-Type": "application/json" }
  });
  return result.data;
};

export const getLeaveDetail = async (data) => {
  const result = await Request.post("getleavedetail", data, {
    headers: { Accept: "application/json, */*", "Content-Type": "application/json" }
  });
  return result.data;
};

export const updateLeaveStatus = async (data) => {
  const result = await Request.post(Routes.UPDATELEAVESTATUS, data, {
    headers: { Accept: "application/json, */*", "Content-Type": "application/json" }
  });
  return result.data;
};
